(function(){
  function initReveal(){
    var nodes=document.querySelectorAll('.reveal:not(.in)');
    if(!('IntersectionObserver' in window)){nodes.forEach(function(n){n.classList.add('in')});return;}
    var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},{threshold:.12});
    nodes.forEach(function(n){io.observe(n)});
  }
  function initGaze(){
    var el=document.querySelector('.iris'); if(!el) return;
    if(!window.matchMedia('(hover:hover)').matches) return;
    if(window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    var tx=0,ty=0,gx=0,gy=0;
    window.addEventListener('mousemove',function(e){
      var iris=document.querySelector('.iris'); if(!iris) return;
      var r=iris.getBoundingClientRect();
      var ox=e.clientX-(r.left+r.width/2), oy=e.clientY-(r.top+r.height/2);
      var d=Math.hypot(ox,oy)||1, max=7, f=Math.min(1,d/(r.width/2));
      tx=(ox/d)*max*f; ty=(oy/d)*max*f;
    });
    (function loop(){gx+=(tx-gx)*.08;gy+=(ty-gy)*.08;var g=document.querySelector('.gaze');if(g)g.setAttribute('transform','translate('+gx.toFixed(2)+' '+gy.toFixed(2)+')');requestAnimationFrame(loop);})();
  }
  function initGallery(){
    document.querySelectorAll('[data-gallery-thumb]').forEach(function(btn){btn.addEventListener('click',function(){var main=document.querySelector('[data-gallery-main]');if(main)main.src=btn.dataset.galleryThumb;});});
  }
  function initMobile(){
    var b=document.querySelector('[data-menu-toggle]'),m=document.querySelector('[data-mobile-menu]');
    if(b&&m)b.addEventListener('click',function(){m.style.display=m.style.display==='none'?'block':'none';});
  }
  document.addEventListener('DOMContentLoaded',function(){initReveal();initGaze();initGallery();initMobile();});
  document.addEventListener('shopify:section:load',function(){initReveal();initGaze();initGallery();initMobile();});
  window.addEventListener('scroll',function(){var h=document.getElementById('hdr');if(h)h.classList.toggle('scrolled',window.scrollY>40);});
})();